import React, { useCallback } from 'react';
import classNames             from 'classnames';
import { useTranslation }     from 'react-i18next';

import RenderButton          from '../../../components/buttons/base/RenderButton';
import CompareAddProductIcon from '../../../components/icons/CompareAddProductIcon';
import { ShareBlock }        from '../../../components/share';
import { useUser }           from '../../../providers/user';

const CompareStickyProductCard = function(props) {
  const {
          compareOffers,
          isIntersecting,
          goToCatalog,
          scroll,
        } = props;

  const {
          t,
          i18n: { language },
        } = useTranslation();

  const {
          addToBookmarks,
          bookmarks,
        } = useUser();

  const getSubTitle = useCallback((offer) => {
    if (!offer) {
      return null;
    }

    const {
            installationTypeUrlKey,
            tags,
          } = offer;

    if (tags && tags.find(({ tagId }) => tagId === 2)) {
      return t('client_with_smart_lock');
    }

    if (installationTypeUrlKey === 'v-dom') {
      return t('client_entrance_door_for_house');
    }

    if (installationTypeUrlKey === 'v-kvartiru') {
      return t('client_entrance_door_for_flat');
    }
  }, [language]);

  const inBookmarks = useCallback((modelId, offerId) => {
    return bookmarks.hasOwnProperty(modelId) && bookmarks[modelId].hasOwnProperty(`_${offerId}`);
  }, [bookmarks]);

  return (
    <div
      className={classNames('offers_common_container', { visible: !isIntersecting })}
      style={{ transform: `translateX(-${scroll}px)` }}
    >
      {compareOffers.map((offer, index) => {
        const currentOffer = offer.common;

        return (
          <div className={'offer_common'} key={index}>
            <p className={'title'}>{currentOffer.label}</p>
            <div className={'bottom_wrapper'}>
              <p className={'sub_title'}>{getSubTitle(currentOffer)}</p>
              <div className={'vendor_code_container'}>
                <p className={'vendor_code'}>{currentOffer.vendorCode}</p>
                <div className={'bottom_btns_container'}>
                  <ShareBlock link={currentOffer.urlKey} />
                  <RenderButton
                    icon={
                      <span className={inBookmarks(currentOffer.modelId, currentOffer.offerId) ? 'ic-like-fill' : 'ic-like'} />}
                    action={() => addToBookmarks(currentOffer)}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <div
        className={'add_product_fixed'}
        onClick={goToCatalog}
      >
        <CompareAddProductIcon />
        <p>{t('client_add_product')}</p>
      </div>
    </div>
  );
};

export default CompareStickyProductCard;
